import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { Sex } from "@roman/shared/types/UserBase";
import type { AxiosResponse } from "axios";
import type { SWRMutationConfiguration } from "swr/mutation";
import useSWRMutation from "swr/mutation";

type UpdateUserArg = {
  userId: string;
  photoUrl?: string;
  telegramUserName?: string;
  age?: number | null;
  sex?: Sex | null;
};

// Fetcher
const putUpdateUserRequest = async (url: string, { arg }: { arg: UpdateUserArg }): Promise<AxiosResponse<void>> => {
  const headers = authHeader.getOrThrow();
  return romanApi.patch(
    `${url}/${arg.userId}`,
    {
      photoUrl: arg.photoUrl,
      telegramUserName: arg.telegramUserName,
    },
    { headers },
  );
};

export const useUpdateUser = (
  options?: SWRMutationConfiguration<AxiosResponse<any>, RomanApiError, "/user", UpdateUserArg>,
) => {
  return useSWRMutation("/user", putUpdateUserRequest, options);
};
